// Predicate-generating function. Often useful outside of Underscore.
export default function noop(){}



//////////////////
// WEBPACK FOOTER
// ./~/_underscore@1.13.2@underscore/modules/noop.js
// module id = 539
// module chunks = 106